import React from 'react';
import { format } from 'date-fns';
import { DATE_FORMAT, dayContentClassName } from './constants';
export function DayContent({ date }) {
    const value = format(date, DATE_FORMAT.d);
    return (React.createElement("div", { className: dayContentClassName, "data-value": value }, value));
}
